import { render } from "./PosterInfo.vue?vue&type=template&id=4be8cbfb&scoped=true"
import script from "./PosterInfo.vue?vue&type=script&lang=js"
export * from "./PosterInfo.vue?vue&type=script&lang=js"

import "./PosterInfo.vue?vue&type=style&index=0&id=4be8cbfb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be8cbfb"]])

export default __exports__